<li role="menuitem">
    <div class="notification-item">
      <div class="notification-summary">
      <div class="p-mb-2">
        {{naziv}}
      </div>
        <div class="progress-bar-wrapper">
          <p-progressBar
            card-subtitle
            [value]="progressPercent"
            [showValue]="false"
            [ngClass]="'progress'"
            ></p-progressBar>
          <span class="progress-bar-label">{{ progressPercent }}%</span>
        </div>
      </div>
    </div>
</li>
